import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACCESS_TOKEN } from "../../common/constant";
import {
  getWishesList,
  selectWishesList,
} from "../../redux/reducers/slice/profile";
import { products } from "../../services";
import { checkProductWish } from "../../shared/helpers";
import AuthModal from "./authModal";
import "./style.scss";
interface IWishButtonProps {
  //   wishStatus: boolean;
  //   setWishStatus: Function;
  feature: any;
  spec?: any;
}

const WishButton = (props: IWishButtonProps) => {
  const { feature, spec } = props;
  const [wishStatus, setWishStatus] = React.useState(false);
  const [isSignInModal, setIsSignInModal] = React.useState(false);
  const wishesList = useSelector(selectWishesList);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const item = {
      product_feature_code: feature?.value,
      kde_pro_id: spec?.kde_pro_id || null,
      kde_pro_spec_id: spec?.kde_pro_spec_id || null,
    };

    const _wish = checkProductWish(item, wishesList);

    setWishStatus(_wish);
  }, [feature, wishesList]);

  const handleHeart = (
    product_feature_code: string,
    kde_pro_id: string,
    kde_pro_spec_id: number
  ) => {
    if (localStorage.getItem(ACCESS_TOKEN) === null) {
      openAuthModal();
    } else {
      products.editProductWishV2(
        {
          product_feature_code,
          kde_pro_id,
          kde_pro_spec_id,
          wish: !wishStatus,
        },
        (data, err) => {
          if (data) {
            dispatch(getWishesList({ offset: 0, limit: 1000 }));
          }
        }
      );
    }
  };

  const openAuthModal = () => {
    setIsSignInModal(true);
  };

  const closeAuthModal = () => {
    setIsSignInModal(false);
  };

  return (
    <>
      <a
        className="button-heart"
        onClick={() =>
          handleHeart(
            feature?.value,
            spec?.kde_pro_id || null,
            spec?.kde_pro_spec_id || null
          )
        }>
        {/* {wishStatus ? (
          <div className="icon-heart icon-heart--added" />
        ) : (
          <div className="icon-heart icon-heart--add" />
        )} */}
        <img
          src={
            wishStatus
              ? "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_heart-51.svg"
              : "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_heart-50.svg"
          }
          alt=""
        />
      </a>
      <AuthModal
        isSignInModal={isSignInModal}
        closeAuthModal={closeAuthModal}
        {...props}
      />
    </>
  );
};

export default WishButton;
